import preact from 'preact'
import renderToString from 'preact-render-to-string'
import isBeingCrawledByReactSnapshot from './isBeingCrawledByReactSnapshot'

const render = (rootComponent, domElement) => {
  if (isBeingCrawledByReactSnapshot()) {
    console.log('rendering react snapshot')
    domElement.innerHTML = renderToString(rootComponent)
    console.log('rendered to string')
    window.reactSnapshotRender()
    console.log('calling reactSnapshotRender')
  } else {
    preact.render(rootComponent, domElement)
  }
}

export default render



// WEBPACK FOOTER //
// ./src/render.js